const substr = (text, length) => text.length > length ? `${text.substr(0, length - 3)}...` : text;
// TODO extra check params + optional append after
export { substr };
